import React from 'react';

export default (svg: string) => (iconProps: any) => (
  <div {...iconProps} dangerouslySetInnerHTML={{ __html: svg }} />
);
